import React from 'react';
import './ArtHero.css';

const ArtHero = () => {
    return (
        <section className="art-hero">
            <div className="art-hero__container">
                {/* Left side - Featured Image */}
                <div className="art-hero__canvas-placeholder">
                    <img 
                        src="/feature-lit.png" 
                        alt="Featured artwork by litterthanlit" 
                        className="art-hero__featured-image"
                    />
                    <div className="art-hero__image-caption">
                        <span className="art-hero__artist">litterthanlit</span>
                        <span className="art-hero__artwork-title">Untitled #7, 2023</span>
                    </div>
                </div>
                
                {/* Right side - Content */}
                <div className="art-hero__content">
                    <div className="art-hero__title-container">
                        <h1 className="art-hero__title">
                            "Colors are a universal language, a lens we see the world through...a window"
                        </h1>
                    </div>
                    <div className="art-hero__text">
                        <p>
                            I use them in my pieces to speak whats on my mind how I'm perceiving the world at that time.
                        </p>
                        <p>
                            Play is the other big element. Through play I'm able to get in a state where I flow.
                            MORE PLAY
                        </p>
                        <div className="art-hero__cta">
                            <a href="/" onClick={(e) => {
                                e.preventDefault();
                                window.dispatchEvent(new CustomEvent('navigateToGallery'));
                            }} className="art-hero__button">Explore the Immuta Collection</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ArtHero;
